export const LAST_YEAR = 'Last Year';
export const LAST_MONTH = 'Last Month';
export const LAST_WEEK = 'Last Week';
export const LAST_DAY = 'Last Day';
export const LATEST = 'Latest';
export const OLDEST = 'Oldest';
export const LEAST_CLICKED = 'Least Clicked';
export const MOST_CLICKED = 'Most Clicked';
